import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../context/LanguageContext';

import styles from "./ResetRequestPage.module.scss";

import { resetRequest } from "../../utils/api/resetrequestAPI"; // Fonction API pour envoyer l'email

// Import des traductions 
import translations from '../../utils/translations/ResetRequestPageTranslations';

const ResetRequest = () => {

  // Utilisation du contexte de langue global
  const { language } = useContext(LanguageContext);

  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState(null);   // Nouveau : état pour le message
  const [error, setError] = useState(null);       // Nouveau : état pour les erreurs

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await resetRequest(email);
      if (response.status === "success") {
        setMessage(t.success);
      } else {
        setError(t.errorGeneric);
      }
    } catch (err) {
      setError(t.errorNetwork);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigation = (event, path) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t.title}</h2>
      <p className={styles.info}>{t.info}</p>
      
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="email"
            placeholder={t.emailPlaceholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? t.sending : t.send}
        </button>
      </form>

      {message && <p className={styles.success}>{message}</p>}
      {error && <p className={styles.error}>{error}</p>}

      {message && (
        <p>
          <button
            type="button"
            onClick={(e) => handleNavigation(e, "/login")}
            className={styles.linkButton}
          >
            {t.loginCta}
          </button>
        </p>
      )}
    </div>
  );
};

export default ResetRequest;
